import React, {useEffect, useState} from "react";
import {TextField} from "@mui/material";
import {getBackendEntityMessage} from "../sistemasUtils";

/*
 * Campo que grava ao sair dele (ou com Enter, no campo de uma linha), mesmo que o resto esteja incompleto.
 * O que a tela recusa (`validar`) e o que a API recusa ficam no próprio campo, com o texto digitado,
 * para a pessoa corrigir; nada é gravado até lá.
 */
export default function CampoAutoSalvo({
    value,
    onSalvar,
    validar,
    helperText,
    multiline = false,
    mono = false,
    disabled = false,
    InputProps,
    inputProps,
    ...props
}) {
    const atual = value ?? '';
    const [rascunho, setRascunho] = useState(atual);
    const [erro, setErro] = useState('');
    const [salvando, setSalvando] = useState(false);
    const [focado, setFocado] = useState(false);

    // O valor da API manda enquanto a pessoa não está digitando.
    useEffect(() => {
        if (!focado) setRascunho(atual);
    }, [atual, focado]);

    const salvar = async () => {
        setFocado(false);
        const novo = multiline ? rascunho : rascunho.trim();
        if (novo === atual) {
            setRascunho(atual);
            setErro('');
            return;
        }
        const recusa = validar?.(novo) || '';
        if (recusa) {
            setErro(recusa);
            return;
        }
        setSalvando(true);
        try {
            await onSalvar(novo);
            setErro('');
        } catch (error) {
            setErro(getBackendEntityMessage(error, 'Não foi possível salvar.'));
        } finally {
            setSalvando(false);
        }
    };

    return (
        <TextField
            {...props}
            fullWidth
            value={rascunho}
            disabled={disabled}
            multiline={multiline}
            error={Boolean(erro)}
            helperText={erro || (salvando ? 'Salvando…' : helperText)}
            onFocus={() => setFocado(true)}
            onChange={(event) => setRascunho(event.target.value)}
            onBlur={salvar}
            onKeyDown={(event) => {
                if (!multiline && event.key === 'Enter') event.target.blur();
            }}
            InputProps={{...InputProps, sx: {...(mono ? {fontFamily: 'monospace'} : {}), ...InputProps?.sx}}}
            inputProps={inputProps}
        />
    );
}
